<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-5">
        <lib-page-header page-title="PRÉ-LIQUIDAÇÕES"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/invoice3.png">
        </lib-page-header>
      </div>
      <div class="col-md-7">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <div class="dropdown float-right ml-2">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenu2"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir liquidações" height="20" width="20">
          </button>
          <div class="dropdown-menu  dropdown-menu-right" aria-labelledby="dropdownMenu2">
            <a [routerLink]="['/pre-liquidacoes', 'relatorios']" class="dropdown-item">
              Listagem de liquidações
            </a>
            <button data-toggle="modal" data-target="#notaLiquidacao" class="dropdown-item" type="button">
              Notas de pré-liquidações
            </button>          
          </div>
        </div>

        <a *ngIf="podeIncluir()" [routerLink]="['/pre-liquidacoes/novo']"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="form-group col-md-2">
        <p-calendar id="data1" [(ngModel)]="data1" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="form-group col-md-2">
        <p-calendar id="data2" [(ngModel)]="data2" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <em class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></em>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" class="text-center"></th>
                <th scope="col" class="text-center">Empenho Nº</th>
                <th scope="col" class="text-center">Data</th>
                <th scope="col">Favorecido</th>
                <th scope="col">Descrição despesa</th>
                <th scope="col" class="text-right"></th>
                <th scope="col" class="text-right">Valor pré-Liquidado</th>
                <th scope="col" style="width: 50px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td style="width: 16px;">
                  <span *ngIf="item.impresso"><img src="assets/img/global/bullet_green.png" alt="" height="16"
                      width="16" title="Impresso"></span>
                  <span *ngIf="!item.impresso"><img src="assets/img/global/bullet_yellow.png" alt="" height="16"
                      width="16" title="Não impresso"></span>
                </td>
                <th scope="row" class="text-center" style="width: 108px;">
                  {{("00000"+item.empenho.numero).slice(-5)}}
                  <span *ngIf="item.parcela > 0">- {{item.parcela}}</span>
                </th>
                <td class="text-center">{{item.data_liquidacao | date:'dd/MM/yyyy':'GMT'}}</td>
                <td>
                  <span class="text-muted">{{item.empenho.favorecido.cpf_cnpj | CPF}}</span>
                  {{item.empenho.favorecido.nome}}
                </td>
                <td>{{item.empenho.subelemento.codigo}} {{item.empenho.subelemento.nome}}</td>
                <td>
                  <span *ngIf="item.anulacao" class="badge badge-danger">ANULADO</span>
                </td>
                <td class="text-right">{{item.valor_liquidado | number:'1.2-2'}}</td>
                <td class="text-right" style="min-width: 150px">
                  <button (click)="anular(item)"
                    *ngIf="!item.anulacao && podeIncluir() && podeAlterar(item.data_liquidacao)"
                    class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/coins_delete.png" alt="Anular" title="Anular pré-liquidação" height="16"
                      width="16">
                  </button>                 
                  <button [routerLink]="['/pre-liquidacoes', item.id, 'visualizar']" routerLinkActive="router-link-active"
                    *ngIf="!podeIncluir() || !podeAlterar(item.data_liquidacao)"
                    class="btn btn-sm btn-outline-secondary mr-2" title="Visualizar">
                    <img src="assets/img/global/zoom.png" height="16" alt="" width="16">
                  </button>
                  <button [routerLink]="['/pre-liquidacoes', item.id, 'editar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir() && podeAlterar(item.data_liquidacao)"
                    class="btn btn-sm btn-outline-primary mr-2" title="Editar">
                    <img src="assets/img/global/pencil.png" alt="" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>

<lib-pre-liquidacao-anulacao [login]="login" [empNumero]="liquidacaoAnular?.empenho?.numero"
  [idLiquidacao]="liquidacaoAnular?.id">
</lib-pre-liquidacao-anulacao>